import React from 'react';
import { useClient } from '$/api';
import { InfiniteCoreApiTable } from '$/components/CoreApiTable';
import { TestrunColumnDefinitions } from '$/features/components/Testruns/TestrunColumnDefinitions';
import { HostData } from '@amzn/dots-host-agent-management-service-client';

export type HostTestrunsListProps = {
  host: HostData;
};

export function HostTestrunsList({ host }: HostTestrunsListProps): JSX.Element {
  const { testruns } = useClient();

  return (
    <InfiniteCoreApiTable
      resourceKey={testruns.resourceKey}
      getAll={testruns.getAll}
      visibleColumnIds={TestrunColumnDefinitions.map((col) => col.id)}
      columns={TestrunColumnDefinitions}
      params={{ hostname: host.hostName! }}
    />
  );
}
